import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.remove';
import 'mdn-polyfills/Node.prototype.children';

import * as pbi from 'powerbi-client';

function createFilters(filterConfig) {
  const filters = [];
  for (let config of filterConfig) {
     const basicFilter = {
	    $schema: "http://powerbi.com/product/schema#basic",
	    target: {
	        table: config.table, 
	        column: config.column, 
	    },
	    operator: config.operator, 
	    values: config.values,
	    filterType: pbi.models.FilterType.Basic,
	    displaySettings: {
                isLockedInViewMode: config.isLockedInViewMode,
                isHiddenInViewMode: config.isHiddenInViewMode,
                displayName: config.displayName
        }
	  }
    filters.push(basicFilter);
  }
  return filters;
}

function startPowerBi(div, accessToken, embedUrl, reportId, mobile, settings, filterConfig) {

	// Embed configuration used to describe the what and how to embed.
	// This object is used when calling powerbi.embed.
	// This also includes settings and options such as filters.
	// You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.
	var config = {
	    type: 'report',
	    tokenType: pbi.models.TokenType.Embed,
	    accessToken: accessToken,
	    embedUrl: embedUrl,
	    id: reportId,
	    permissions: pbi.models.Permissions.All,
	    filters: createFilters(filterConfig),
	};
	
	config.settings = settings === undefined ? 
			{ filterPaneEnabled: true, navContentPaneEnabled: true} : settings;
			
	if(mobile) {
		config.settings.layoutType = pbi.models.LayoutType.MobilePortrait;
	}

	// Embed the report and display it within the div container.
	var powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
	var report = powerbi.embed(div, config);
	
	return {"pbi" : powerbi, "report" : report};
}

export const ubapowerbi = {
  startPowerBi
};
window.ubapowerbi = ubapowerbi;
window.pbi = pbi;